import { CHECKMEPRO_CRC, CHECKMEPRO_HEADER } from "../BleContstants";
var delay = function (delayInms) {
    return new Promise(function (resolve) { return setTimeout(resolve, delayInms); });
};
export function getInfoPackage() {
    var buf = new Int8Array(8); // t.value.byteLength how many bytes are there?
    buf[0] = CHECKMEPRO_HEADER;
    buf[1] = 0x14;
    buf[2] = ~0x14;
    buf[3] = 0; //Package number, the default is 0
    buf[4] = 0;
    buf[5] = 0; //data chunk size, the default is 0
    buf[6] = 0;
    buf[7] = crc8(buf); //0xC6;
    return buf;
}
export function checkErrorLog(data) {
    if (data[0] == 1) {
        this.LAST_COMMAND = 0;
        this.LAST_FILE_COMMAND = 0;
        console.log("error");
        return true;
    }
    return false;
}
export function getReadStartPackage(filename) {
    var buf = new Int8Array(8 + filename.length + 1); // t.value.byteLength how many bytes are there?
    buf[0] = CHECKMEPRO_HEADER;
    buf[1] = 0x03;
    buf[2] = ~0x03;
    buf[5] = buf.length - 8;
    for (var i = 0; i < filename.length; i++) {
        var char = filename.charCodeAt(i);
        buf[7 + i] = char;
    }
    buf[buf.length - 1] = crc8(buf);
    return buf;
}
export function getReadDataPackage(packageNB) {
    var buf = new Int8Array(8); // t.value.byteLength how many bytes are there?
    buf[0] = CHECKMEPRO_HEADER;
    buf[1] = 0x04;
    buf[2] = ~0x04;
    buf[3] = packageNB;
    buf[4] = 0;
    buf[5] = 0;
    buf[7] = crc8(buf);
    return buf;
}
export function getEndReadPackage() {
    var buf = new Int8Array(8); // t.value.byteLength how many bytes are there?
    buf[0] = CHECKMEPRO_HEADER;
    buf[1] = 0x05;
    buf[2] = ~0x05;
    buf[3] = 0;
    buf[4] = 0;
    buf[7] = crc8(buf);
    return buf;
}
export function getPingPackage() {
    var buf = new Int8Array(8); // t.value.byteLength how many bytes are there?
    buf[0] = CHECKMEPRO_HEADER;
    buf[1] = 0x15;
    buf[2] = 0xea;
    buf[7] = crc8(buf);
    return buf;
}
export function crc8(buf) {
    var crc = 0;
    var max = 0x00ff;
    for (var i = 0; i < buf.length - 1; i++) {
        crc = CHECKMEPRO_CRC[max & (crc ^ buf[i])];
    }
    return crc;
}
export function getDateTime(buffer, startPos) {
    var year = (buffer[startPos] & 0xff) + ((buffer[startPos + 1] & 0xff) << 8);
    var month = buffer[startPos + 2] - 1;
    var day = buffer[startPos + 3];
    var hour = buffer[startPos + 4];
    var minute = buffer[startPos + 5];
    var second = buffer[startPos + 6];
    return new Date(year, month, day, hour, minute, second);
}
